// @styles
require('./amazonCouponCodeFilter.scss');
// @vendors
const React = require('react');
const PropTypes = require('prop-types');
// @commons
const DateFilter = require('components/commons/dateFilter/dateFilter');
const OKModal = require('components/commons/OKModal/OKModal');
//@constants
const { DATE_FILTER_NONE } = require('constants/index');
const {
    AMAZON_CODIGOS_FILTER_MODAL,
    AMAZON_CODIGOS,
} = require('constants/tagging');

//@utils
const { recordLinkV2 } = require("utilities/tagging");

class AmazonCouponCodeFilter extends React.Component {

    constructor(props) {
        super(props);
        const { immFilter } = props;
        this.state = {
            dateSelected: immFilter.getIn(['date','selected']),
            dateFrom: immFilter.getIn(['date','from']),
            dateTo: immFilter.getIn(['date','to'])
        };
        this.handleCancelClick = this.handleCancelClick.bind(this);
        this.handleClose = this.handleClose.bind(this);
        this.handleFormSubmit = this.handleFormSubmit.bind(this);
        this.handleChangeDateMin = this.handleChangeDateMin.bind(this);
        this.handleChangeDateMax = this.handleChangeDateMax.bind(this);
        this.handleChangeDateSelected = this.handleChangeDateSelected.bind(this);
        this.handleRecordLink = this.handleRecordLink.bind(this);
    }

    componentDidUpdate(prevProps) {
        const {
            isOpen
        } = this.props;

        if(prevProps.isOpen !== isOpen && isOpen){
            this.handleRecordLink("open");
        }
    }

    handleRecordLink(etiquetaEvento) {
        const customData = ({
            categoriaEvento: AMAZON_CODIGOS,
            accionEvento: AMAZON_CODIGOS_FILTER_MODAL,
            etiquetaEvento
        });
        recordLinkV2(customData);
    }

    handleChangeDateMax(dateTo) {
        this.setState({
            dateTo
        });
    }

    handleChangeDateMin(dateFrom) {
        this.setState({
            dateFrom
        });
    }

    handleChangeDateSelected(dateSelected) {
        this.setState({
            dateSelected
        });
        this.handleRecordLink(this.state.dateSelected);
    }

    handleClose() {
        const { onCloseClick } = this.props;
        this.handleRecordLink("close");
        onCloseClick();
    }

    handleCancelClick() {
        const { onCloseClick } = this.props;
        this.handleRecordLink("cancelar");
        onCloseClick();
    }

    handleFormSubmit() {
        const { onCloseClick, setFilters } = this.props;
        const { dateFrom, dateTo, dateSelected } = this.state;
        setFilters({
            date: {
                isActive: dateSelected !== DATE_FILTER_NONE,
                selected: dateSelected,
                from: dateFrom,
                to: dateTo
            }
        });
        this.handleRecordLink("aplicar");
        onCloseClick();
    }

    render() {
        const { immFilter, isOpen } = this.props;
        const contentModal = (            
            <DateFilter
                immFilter={immFilter.get('date')}
                onChangeMin={this.handleChangeDateMin}
                onChangeMax={this.handleChangeDateMax}
                onChangeSelected={this.handleChangeDateSelected}
                showAnnual={false}
            />
        );

        return (
            <OKModal
                content={contentModal}
                footerType="navigation"
                isOpen={isOpen}
                onPrimaryButtonClick={this.handleFormSubmit}
                onSecondaryButtonClick={this.handleCancelClick}
                primaryButtonText="filterDate-apply"
                secondaryButtonText="filterDate-cancel"
                title="amazonGiftCard-filtersTitle"
                onCloseCallback={this.handleClose}
                type="filter"
            />
        );
    }
}

AmazonCouponCodeFilter.propTypes = {
    immFilter: PropTypes.object.isRequired,
    isOpen: PropTypes.bool.isRequired,
    onCloseClick: PropTypes.func.isRequired,
    setFilters: PropTypes.func
};

export default AmazonCouponCodeFilter;
